import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaRegCircleUser } from 'react-icons/fa6';
import ROLE from '../common/role';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import SummaryApi from '../common';
import { toast } from 'react-toastify';

const UserProfile = () => {
  const user = useSelector(state => state?.user?.user); // Get user details from redux
  const location = useLocation(); // Get current location
  const [loading, setLoading] = useState(true); 
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [userDetails, setUserDetails] = useState({
    profilePic:user?.profilePic || '',
    name: user?.name || '',
    shippingAddress: user?.shippingAddress || '',
    mobileNumber: user?.mobileNumber || '',
    purchasingManager: user?.purchasingManager || '',
    pharmacistOrPharmacy:user?.pharmacistOrPharmacy || '',
    governorate: user?.governorate || '',
    region: user?.region || '',
    certificatePic: user?.certificatePic || ''
  });

  useEffect(() => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => {
      setLoading(false);
      navigate("/");
    }, 10000); 

    if (user) {
      if (user?.role !== ROLE.GENERAL) {
        navigate("/");
        setLoading(false);
      } else {
        setLoading(false);
        clearTimeout(loadingTimeout);
        fetchUserDetails();
      }
    } 
    

    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);


  const fetchUserDetails = async () => {
    try {
        const response = await fetch(SummaryApi.current_user.url, {
            method: SummaryApi.current_user.method,
            credentials: 'include',
            headers: {
                'content-type': 'application/json',
            },
        });
        const responseData = await response.json();
        if (responseData.success) {
            setUserDetails(responseData?.data);
        } else {
            toast.error('حدث خطأ');
        }
    } catch (error) {
        toast.error('حدث خطأ');
    }
};

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
    );
  }
  
  return (
    <div className='min-h-[calc(100vh-120px)] lg:flex'>
      {/* Mobile Toggle Button */}
      <button onClick={toggleSidebar} className="lg:hidden fixed top-20 left-4 z-50 bg-blue-900 text-white p-2 rounded-full">
        {isSidebarOpen ? <AiOutlineClose size={18} /> : <AiOutlineMenu size={18} />}
      </button>
      {/* Sidebar */}
      <aside className={`lg:block w-full max-w-60 customShadow transition-transform duration-300 ease-in-out
                  ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
                  fixed lg:relative z-10 bg-white lg:bg-transparent lg:translate-x-0 h-full lg:h-auto top-18`}>

                          
  <div className='h-32 flex justify-center items-center flex-col'>
    <div className='text-5xl cursor-pointer relative flex justify-center'>
      {userDetails?.profilePic ? (
        <img src={userDetails?.profilePic} className='w-20 h-20 rounded-full' alt={userDetails?.name} />
      ) : (
        <FaRegCircleUser />
      )}
    </div>
    <p className='capitalize text-lg font-semibold'>{userDetails?.name}</p>
    <p className='text-sm'>{userDetails?.pharmacistOrPharmacy === 'pharmacy' ? 'صيدلية' : userDetails?.pharmacistOrPharmacy === 'pharmacist' ? 'عميل' : userDetails?.pharmacistOrPharmacy}</p>
  </div>

  {/* Navigation */}
  <div>
    <nav className='grid p-4'>
      {/* معلومات شخصية */}
      <div className='mb-4'>
        <h3 className='text-xl font-bold mb-2 text-center'>المعلومات الشخصية</h3>
        <Link
          to='/userProfile'
          className={`block px-2 py-1 ${location.pathname === '/userProfile' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          الملف الشخصي
        </Link>
        <Link
          to='/userEditProfile'
          className={`block px-2 py-1 ${location.pathname === '/userEditProfile' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          تعديل الملف الشخصي
        </Link>
        <Link
          to='/changePassword'
          className={`block px-2 py-1 ${location.pathname === '/changePassword' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          تغيير كلمة المرور
        </Link>
      </div>



    </nav>
  </div>
</aside>


      {/* Main content */}
      <main className={`w-full h-full p-2 ${isSidebarOpen ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>
        <div className="container max-w-xl mx-auto p-5" style={{ marginLeft: '20px' }}>
          <div className="flex flex-col items-center mb-5">
            <h2 className="text-2xl font-bold mb-5"> الملف الشخصي</h2>
            <div className="flex flex-col items-center space-y-4">
              {/* Profile Image */}
              <div className='w-24 h-24 rounded-full overflow-hidden'>
                {userDetails?.profilePic ? (
                  <img src={userDetails?.profilePic} alt="Profile" className='w-full h-full object-cover' />
                ) : (
                  <FaRegCircleUser className='text-6xl text-gray-500' />
                )}
              </div>
              {/* User Name */}
              <div>
                <h3 className="text-xl font-semibold text-center">{userDetails?.name}</h3>
              </div>
            </div>
          </div>

          {/* User Information */}
          <div className="space-y-4">
            <div>
              <h3 className="font-semibold text-right">: البريد الالكتروني</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{userDetails?.email}</p>
            </div>

            <div>
            <h3 className="font-semibold text-right">: مدير المشتريات</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{userDetails?.purchasingManager}</p>
            </div>

            
            <div>
            <h3 className="font-semibold text-right">: نوع المستخدم</h3>
            <p className="border rounded p-1 bg-gray-50 text-sm">
              {userDetails?.pharmacistOrPharmacy === 'pharmacy' ? 'صيدلية' :userDetails?.pharmacistOrPharmacy === 'pharmacist'?'عميل':userDetails?.pharmacistOrPharmacy }
            </p>
          </div>


            <div>
              <h3 className="font-semibold text-right">: المدينة</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{userDetails?.governorate || 'لا يوجد اسم محافظة متاح'}</p>
            </div>
           {userDetails?.governorate==='طرابلس'&& <div>
              <h3 className="font-semibold text-right">: المنطقة</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{userDetails?.region || 'لا يوجد اسم منطقة متاح'}</p>
            </div>  
            }
                        <div>
              <h3 className="font-semibold text-right">: عنوان التوصيل</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{userDetails?.shippingAddress || 'لا يوجد عنوان متاح'}</p>
            </div>
            <div>
              <h3 className="font-semibold text-right">: رقم الهاتف المحمول</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{userDetails?.mobileNumber || 'لا يوجد رقم هاتف محمول متاح'}</p>
            </div>
{/*
            <div>
              <h3 className="font-semibold text-right">: اجمالى المديونية</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">
                {displayINRCurrency(totalDebt.toFixed(2))}
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-right">: مديونية شركة دواكو</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">
                {displayINRCurrency(medicineDebt.toFixed(2))}
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-right">: مديونية شركة مستحضرات التجميل</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">
                {displayINRCurrency(cosmeticDebt.toFixed(2))}
              </p>
            </div>
*/}
            <div className="flex flex-col items-center">
              <h3 className="font-semibold text-right w-full">: شهادة التوثيق</h3>
              <div className='w-30 h-24 overflow-hidden mt-4 flex justify-center items-center'>
                {userDetails?.certificatePic ? (
                  <img src={userDetails?.certificatePic} alt="شهادة التوثيق" className='w-full h-full object-cover' />
                ) : (
                  <FaRegCircleUser className='text-6xl text-gray-500' />
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserProfile;
